import React from 'react';
import { Lock, ShieldCheck } from 'lucide-react';

export function PaymentBadges({ className = "", showTitle = true }) {
    return (
        <div className={`space-y-3 ${className}`}>
            {showTitle && (
                <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
                    <ShieldCheck className="h-4 w-4 text-green-500" />
                    <span>Paiement 100% sécurisé</span>
                </div>
            )}
            
            <div className="flex flex-wrap items-center justify-center gap-3">
                {/* Visa */}
                <div className="h-8 px-2 bg-white rounded border flex items-center justify-center" title="Visa">
                    <svg viewBox="0 0 50 50" className="h-6 w-auto">
                        <path fill="#1A1F71" d="M19.5 33.5h-4.2l2.6-16h4.2l-2.6 16zm17.8-15.6c-.8-.3-2.1-.7-3.7-.7-4.1 0-7 2.2-7 5.3 0 2.3 2.1 3.6 3.7 4.4 1.6.8 2.2 1.3 2.2 2 0 1.1-1.3 1.6-2.5 1.6-1.7 0-2.6-.2-4-.8l-.5-.3-.6 3.5c1 .5 2.8.9 4.7.9 4.4 0 7.2-2.1 7.2-5.4 0-1.8-1.1-3.2-3.5-4.3-1.5-.7-2.4-1.2-2.4-2 0-.7.8-1.4 2.4-1.4 1.4 0 2.4.3 3.2.6l.4.2.6-3.6zm10.8-.4h-3.2c-1 0-1.7.3-2.2 1.3l-6.1 14.7h4.4l.9-2.4h5.3l.5 2.4h3.9l-3.5-16zm-5.1 10.3l1.6-4.3c0 0 .3-.9.5-1.5l.3 1.4.9 4.4h-3.3zM15.3 17.5l-4 10.9-.4-2.2c-.8-2.5-3.1-5.3-5.7-6.6l3.7 13.9h4.4l6.5-16h-4.5z"/>
                        <path fill="#F9A533" d="M8.3 17.5H1.9l-.1.4c5.2 1.3 8.7 4.5 10.1 8.3l-1.5-7.4c-.2-1-.9-1.2-2.1-1.3z"/>
                    </svg>
                </div>
                
                {/* Mastercard */}
                <div className="h-8 px-2 bg-white rounded border flex items-center justify-center" title="Mastercard">
                    <svg viewBox="0 0 50 50" className="h-6 w-auto">
                        <circle cx="15" cy="25" r="15" fill="#EB001B"/>
                        <circle cx="35" cy="25" r="15" fill="#F79E1B"/>
                        <path fill="#FF5F00" d="M25 12.5c3.8 3 6.3 7.5 6.3 12.5s-2.5 9.5-6.3 12.5c-3.8-3-6.3-7.5-6.3-12.5s2.5-9.5 6.3-12.5z"/>
                    </svg>
                </div>

                {/* Apple Pay */}
                <div className="h-8 px-3 bg-black rounded border border-gray-700 flex items-center justify-center" title="Apple Pay">
                    <svg viewBox="0 0 50 21" className="h-4 w-auto">
                        <path fill="white" d="M9.6 2.7c.6-.8 1-1.8.9-2.7-.9 0-2 .6-2.6 1.4-.6.7-1.1 1.7-.9 2.7.9.1 1.9-.5 2.6-1.4zM10.5 4.3c-1.5-.1-2.7.8-3.4.8-.7 0-1.8-.8-2.9-.8C2.7 4.4 1.3 5.4.5 7c-1.6 2.8-.4 6.9 1.1 9.2.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.8 3-.8s1.8.8 3 .8c1.2 0 2.1-1.1 2.8-2.3.9-1.3 1.3-2.5 1.3-2.6-.1 0-2.5-1-2.5-3.8 0-2.4 1.9-3.5 2-3.6-1.1-1.7-2.9-1.9-3.6-1.9zM21.1 1.4v17h2.6v-5.8h3.6c3.3 0 5.6-2.3 5.6-5.6s-2.3-5.6-5.5-5.6h-6.3zm2.6 2.2h3c2.3 0 3.6 1.2 3.6 3.4s-1.3 3.4-3.6 3.4h-3V3.6zM38.7 18.6c1.6 0 3.1-.8 3.8-2.1h.1v2h2.4V10.3c0-2.4-1.9-4-4.9-4-2.7 0-4.7 1.6-4.8 3.8h2.4c.2-1 1.2-1.7 2.4-1.7 1.5 0 2.4.7 2.4 2v.9l-3.1.2c-2.9.2-4.5 1.4-4.5 3.5 0 2.2 1.7 3.6 4 3.6zm.7-2c-1.3 0-2.2-.6-2.2-1.6 0-1.1.8-1.7 2.4-1.8l2.8-.2v.9c0 1.5-1.3 2.7-3 2.7zM47.2 21c.3 1.5 1.8 2.6 3.7 2.6v-2.2c-1 0-1.6-.4-1.9-1.3l.3-1L53 6.5h-2.7l-2.5 9.1h-.1l-2.5-9.1h-2.8l4.1 11.4-.3 1.1z"/>
                    </svg>
                </div>

                {/* Société Générale */}
                <div className="h-8 px-2 bg-white rounded border flex items-center justify-center gap-1" title="Société Générale">
                    <div className="w-5 h-5 bg-gradient-to-br from-red-600 to-red-700 rounded-sm flex items-center justify-center">
                        <span className="text-white text-xs font-bold">SG</span>
                    </div>
                    <span className="text-xs font-semibold text-gray-700 hidden sm:inline">Société Générale</span>
                </div>

                {/* CB */}
                <div className="h-8 px-2 bg-white rounded border flex items-center justify-center" title="Carte Bancaire">
                    <div className="flex items-center gap-1">
                        <div className="w-6 h-4 bg-gradient-to-r from-green-600 to-green-500 rounded-sm flex items-center justify-center">
                            <span className="text-white text-[8px] font-bold">CB</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 3D Secure Badge */}
            <div className="flex items-center justify-center gap-2 pt-2">
                <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800 rounded-full">
                    <Lock className="h-3.5 w-3.5 text-green-600" />
                    <span className="text-xs font-medium text-green-700 dark:text-green-400">3D Secure</span>
                    <ShieldCheck className="h-3.5 w-3.5 text-green-600" />
                </div>
            </div>
        </div>
    );
}

// Compact version for footer
export function PaymentBadgesCompact() {
    return (
        <div className="flex flex-wrap items-center justify-center gap-2">
            {/* Visa */}
            <div className="h-6 px-1.5 bg-white rounded border flex items-center justify-center" title="Visa">
                <svg viewBox="0 0 50 50" className="h-4 w-auto">
                    <path fill="#1A1F71" d="M19.5 33.5h-4.2l2.6-16h4.2l-2.6 16zm17.8-15.6c-.8-.3-2.1-.7-3.7-.7-4.1 0-7 2.2-7 5.3 0 2.3 2.1 3.6 3.7 4.4 1.6.8 2.2 1.3 2.2 2 0 1.1-1.3 1.6-2.5 1.6-1.7 0-2.6-.2-4-.8l-.5-.3-.6 3.5c1 .5 2.8.9 4.7.9 4.4 0 7.2-2.1 7.2-5.4 0-1.8-1.1-3.2-3.5-4.3-1.5-.7-2.4-1.2-2.4-2 0-.7.8-1.4 2.4-1.4 1.4 0 2.4.3 3.2.6l.4.2.6-3.6zm10.8-.4h-3.2c-1 0-1.7.3-2.2 1.3l-6.1 14.7h4.4l.9-2.4h5.3l.5 2.4h3.9l-3.5-16zm-5.1 10.3l1.6-4.3c0 0 .3-.9.5-1.5l.3 1.4.9 4.4h-3.3zM15.3 17.5l-4 10.9-.4-2.2c-.8-2.5-3.1-5.3-5.7-6.6l3.7 13.9h4.4l6.5-16h-4.5z"/>
                    <path fill="#F9A533" d="M8.3 17.5H1.9l-.1.4c5.2 1.3 8.7 4.5 10.1 8.3l-1.5-7.4c-.2-1-.9-1.2-2.1-1.3z"/>
                </svg>
            </div>
            
            {/* Mastercard */}
            <div className="h-6 px-1.5 bg-white rounded border flex items-center justify-center" title="Mastercard">
                <svg viewBox="0 0 50 50" className="h-4 w-auto">
                    <circle cx="15" cy="25" r="15" fill="#EB001B"/>
                    <circle cx="35" cy="25" r="15" fill="#F79E1B"/>
                    <path fill="#FF5F00" d="M25 12.5c3.8 3 6.3 7.5 6.3 12.5s-2.5 9.5-6.3 12.5c-3.8-3-6.3-7.5-6.3-12.5s2.5-9.5 6.3-12.5z"/>
                </svg>
            </div>

            {/* Apple Pay */}
            <div className="h-6 px-2 bg-black rounded border border-gray-700 flex items-center justify-center" title="Apple Pay">
                <svg viewBox="0 0 50 21" className="h-3 w-auto">
                    <path fill="white" d="M9.6 2.7c.6-.8 1-1.8.9-2.7-.9 0-2 .6-2.6 1.4-.6.7-1.1 1.7-.9 2.7.9.1 1.9-.5 2.6-1.4zM10.5 4.3c-1.5-.1-2.7.8-3.4.8-.7 0-1.8-.8-2.9-.8C2.7 4.4 1.3 5.4.5 7c-1.6 2.8-.4 6.9 1.1 9.2.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.8 3-.8s1.8.8 3 .8c1.2 0 2.1-1.1 2.8-2.3.9-1.3 1.3-2.5 1.3-2.6-.1 0-2.5-1-2.5-3.8 0-2.4 1.9-3.5 2-3.6-1.1-1.7-2.9-1.9-3.6-1.9zM21.1 1.4v17h2.6v-5.8h3.6c3.3 0 5.6-2.3 5.6-5.6s-2.3-5.6-5.5-5.6h-6.3zm2.6 2.2h3c2.3 0 3.6 1.2 3.6 3.4s-1.3 3.4-3.6 3.4h-3V3.6z"/>
                </svg>
            </div>

            {/* SG */}
            <div className="h-6 px-1.5 bg-white rounded border flex items-center justify-center" title="Société Générale">
                <div className="w-4 h-4 bg-gradient-to-br from-red-600 to-red-700 rounded-sm flex items-center justify-center">
                    <span className="text-white text-[8px] font-bold">SG</span>
                </div>
            </div>

            {/* CB */}
            <div className="h-6 px-1.5 bg-white rounded border flex items-center justify-center" title="Carte Bancaire">
                <div className="w-5 h-3 bg-gradient-to-r from-green-600 to-green-500 rounded-sm flex items-center justify-center">
                    <span className="text-white text-[6px] font-bold">CB</span>
                </div>
            </div>

            {/* 3D Secure mini */}
            <div className="h-6 px-2 bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800 rounded flex items-center justify-center gap-1" title="3D Secure">
                <Lock className="h-3 w-3 text-green-600" />
                <span className="text-[10px] font-medium text-green-700 dark:text-green-400">3D Secure</span>
            </div>
        </div>
    );
}
